import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import { useModalInformacionReingresoSerieStore } from "./useModalInformacionReingresoSerie.store";
import { Grid } from "@mui/material";
import { gridSizeMdLg12} from "@/shared";
import { GeneralTable } from "@/shared/components/ui";
import { IDataMovimientoInventario } from "@/shared/interfaces";
import useKardexByBodega from "@/erp/inventario/kardex/hook/useKardeByBodega";
import { useEffect } from "react";


type ModalInformacionReingresoSerieProps = {  

}

export default function ModalInformacionReingresoSerie({

}: ModalInformacionReingresoSerieProps) {

  const open = useModalInformacionReingresoSerieStore(s => s.open)
  const setOpen = useModalInformacionReingresoSerieStore(s => s.setOpen)
  const serie = useModalInformacionReingresoSerieStore(s => s.serie)

  // hooks
  const {
    form,
    setEnabled,
    columnBase,
    dataKardex,
    isLoadingKardex,
    isRefetchingKardex,
    pagination,
    setPagination,
    columnFilters,
    setColumnFilters,
  } = useKardexByBodega()

  useEffect(() => {
    if (open) {
      setEnabled(true)
      form.setValue('serie', serie || '')
    }
  }, [open])

  return (
    <ScrollableDialogProps
      isCloseIcon={false}
      minWidth="60%"
      onCloseIcon={() => {
        setOpen(false)
      }}
      onClose={() => {
        setOpen(false)
      }}
      cancelTextBtn="Cerrar"
      open={open}
      title={`Movimientos de la Serie`}
      dialogContentText={`Información de los movimientos de la serie: ${serie}`}

      confirmDisabled={false}
      contentNode={
        <Grid container spacing={3}>

          <Grid item {...gridSizeMdLg12}>

            <GeneralTable<IDataMovimientoInventario>
              columns={columnBase}
              data={dataKardex?.data.data || []}
              //
              isLoading={isLoadingKardex}
              isRefetching={isRefetchingKardex}
              // // search
              enableGlobalFilter={false}
              // onGlobalFilterChange={setGlobalFilter}
              // // pagination
              pagination={pagination}
              onPaging={setPagination}
              rowCount={dataKardex?.data?.count}
              // // actions
              actionsColumnSize={120}

              ///* filters - server side
              enableManualFiltering={true}
              columnFilters={columnFilters}
              onColumnFiltersChange={setColumnFilters}
              enableSorting={false}
              enableColumnActions={true}

              // crud
              enableEditing={false}
              positionActionsColumn='first'
            />
          </Grid>

        </Grid>
      }
    />
  )
}